; (function ($) {
  /*===============================================
    Scroll To Top
  ===============================================*/
  $(window).on('scroll', function () {
    $(this).scrollTop() > window.innerHeight
      ? $('a.scrolltotop').fadeIn()
      : $('a.scrolltotop').fadeOut()
  })

  $("a.scrolltotop[href='#top']").click(function () {
    $('html, body').animate({ scrollTop: 0 }, 'easeInOutQuart')
    if ($('body').is('.tax-curriculums')) {
      $("#menu-navigators a").removeClass("active");
      $("#menu-navigators li:first-child a").addClass("active");
    }
    return false
  })

  $(".similar-posts__head__button__top a.gototop[href='#top']").click(
    function () {
      $('html, body').animate({ scrollTop: 0 }, 'easeInOutQuart')
      return false
    }
  )
  /**
   * Category Grid
   */
  if ($('body').hasClass('category')) {
    const categoryGrid = $('.category__content');
    categoryGrid.isotope({
      // options
      itemSelector: '.grid__item',
      masonry: {
        columnWidth: '.grid__sizer',
        gutter: '.grid__gutter',
      },
    });

    categoryGrid.imagesLoaded().done(function () {
      categoryGrid.isotope('layout');
      const $gridItems = $('.grid__item')
      $gridItems.css('opacity', 1)
    });

    // filter functions
    var filterFns = {
      numberGreaterThan50: function () {
        var number = $(this).find('.number').text();
        return parseInt(number, 10) > 50;
      },

      ium: function () {
        var name = $(this).find('.name').text();
        return name.match(/ium$/);
      }
    };

    var activeCategory = '';

    $('.filters-button-group').on('click', 'a', function () {
      var filterValue = $(this).attr('data-filter');

      filterValue = filterFns[filterValue] || filterValue;
      $('.category__content').isotope({ filter: filterValue });
    });


    $('.button-group').each(function (i, buttonGroup) {
      var $buttonGroup = $(buttonGroup);
      $buttonGroup.on('click', 'a', function () {
        if ($(this).hasClass('is-checked')) {
          $('.category__content').isotope({ filter: '*' });
          $(this).removeClass('is-checked');
          return;
        }

        $buttonGroup.find('.is-checked').removeClass('is-checked');
        $(this).addClass('is-checked');
      });
    });
  }

  $(function () {
    if ($('body').hasClass('curriculum')) {
      $('ul.curriculum__content__links li:last-child').mouseenter(function () {
        $(this).prev().css({
          "border-bottom-color": 'transparent'
        });
      });
      $('ul.curriculum__content__links li:last-child').mouseleave(function () {
        $(this).prev().css({
          "border-bottom-color": '#EFECEC'
        });
      });
    }
  });

  $(document).ready(() => {
    // add title to stacked mobile tables
    const tables = document.querySelectorAll('table.is-stacked-on-mobile');

    if (tables.length) {
      tables.forEach(table => {
        const headingElements = table.querySelectorAll('thead th, thead td');

        if (headingElements.length) {
          // filter headings out of thead columns
          const headings = Array.from(headingElements).map(headingElement => headingElement.innerText);

          if(headings.length) {
            // iterate over tbody rows
            const tableRows = table.querySelectorAll('tbody tr');

            if(tableRows.length) {
              // append headings to all row columns
              tableRows.forEach(row => {
                const columns = row.querySelectorAll('td, th');

                if(columns.length) {
                  columns.forEach((column, index) => {
                    if(column.classList.contains('add-title-mobile')) {
                      if(!!headings[index] && headings[index] !== '' && column.innerText !== '') {
                        column.setAttribute('data-heading', "(" + headings[index] + ")");
                      }
                    }
                  });
                }
              })
            }
          }
        }
      });
    }
  });

  	$(window).on('load', function () {
		// store hash from url to a variable
		const $root = $('html, body');
		const target = window.location.hash;

		if (!!target) {
			const $ele = $(target);

			if ($ele.length) {
				$root.animate({
				scrollTop: $ele.offset().top - $('.site-branding').height() - 50
				}, 500);
			}
		}
	});
})(jQuery);

